/** Static Trust Center content — FAQs, subprocessors, hero stats. Certifications come from the Compliances widget. */
export const STATIC_TC = {
    subprocessors: [
        { name: "Amazon Web Services", purpose: "Cloud infrastructure & hosting", location: "Region of your choice", logo: "AWS" },
        { name: "Twilio", purpose: "SMS & voice notifications", location: "United States", logo: "TW" },
        { name: "SendGrid", purpose: "Transactional email delivery", location: "United States", logo: "SG" },
        { name: "Firebase", purpose: "Mobile push notifications", location: "United States", logo: "FB" },
        { name: "Zendesk", purpose: "Customer support tooling", location: "United States", logo: "ZD" },
        { name: "Microsoft Azure", purpose: "Selected regional hosting", location: "Multiple", logo: "AZ" },
    ],
    faqs: [
        { q: "How do I get a copy of your SOC 2 report?", a: "Request access to the document from the Documents tab. Once you accept the NDA, our team approves access — usually within one business day — and you can download it here." },
        { q: "Where is my data stored?", a: "You choose your hosting region during onboarding. Darwinbox operates in India, the EU, US, Middle East, and South-East Asia, with data residency guarantees per region." },
        { q: "Do you support single sign-on?", a: "Yes. We support SAML 2.0 SSO with all major identity providers, plus SCIM provisioning and enforced MFA." },
        { q: "How are vulnerabilities handled?", a: "We run continuous internal testing and engage independent firms for VAPT at least annually. Critical findings are remediated to a defined SLA and tracked to closure." },
        { q: "How do I request a security review?", a: "Reach out to your Darwinbox account team or submit a request through your customer success channel. Our InfoSec team responds to questionnaires, custom DPAs and architecture reviews for enterprise procurement." },
    ],
    stats: [
        { value: 99.99, suffix: "%", label: "Platform uptime", decimals: 2 },
        { value: 20, suffix: "+", label: "Certifications & attestations", decimals: 0 },
        { value: 4, suffix: "M+", label: "Employees secured daily", decimals: 0 },
        { value: 24, suffix: "×7", label: "Security monitoring", decimals: 0 },
    ],
    defaultCategories: [
        {
            id: "infra", name: "Infrastructure", icon: "gear",
            blurb: "Hardened, redundant cloud infrastructure across regions.",
            controls: [
                { name: "Data hosted on AWS", desc: "Production workloads run on Amazon Web Services in ISO-certified data centres." },
                { name: "Encryption at rest", desc: "All customer data encrypted at rest using AES-256." },
                { name: "Encryption in transit", desc: "TLS 1.2+ enforced on every connection." },
            ],
        },
    ],
    defaultOrbitNodes: [
        { icon: "padlock-locked", label: "Encryption at rest & in transit" },
        { icon: "ribbon-star", label: "ISO 27001 & SOC 2 certified" },
        { icon: "key", label: "Least-privilege access" },
        { icon: "person-group", label: "Security-first culture" },
        { icon: "file-shield", label: "Data privacy & residency" },
    ],
}
